// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__6yz5_","title":"Input_title__2d0VP","input":"Input_input__3gn35","button":"Input_button__1wzXP","icon":"Input_icon__p9Bwe"};